if(document.querySelectorAll('.products-showcase__container').length) {
  try {
    var swiper = new Swiper('.products-showcase__container', {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,

      breakpoints: {
        720: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 16,
        },

        1024: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
        },
      },

      pagination: {
        el: ".prods-pagination",
        type: "fraction",
      },

      navigation: {
        nextEl: ".prods-next",
        prevEl: ".prods-prev",
      },
    });
  } catch (e) {
    console.log(e);
  }
}